import { render, staticRenderFns } from "./Extended.vue?vue&type=template&id=1913fdda&scoped=true&lang=pug"
import script from "./Extended.vue?vue&type=script&lang=ts"
export * from "./Extended.vue?vue&type=script&lang=ts"
import style0 from "./Extended.vue?vue&type=style&index=0&id=1913fdda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1913fdda",
  null
  
)

export default component.exports